import { AndroidSettings, IOSSettings, NativeSettings } from "capacitor-native-settings";

interface OpenNativeSettingsProps {
  option: "location" | "application_details" | "settings" | "nfc";
}

const ANDROID_SETTINGS = {
  location: AndroidSettings.Location,
  application_details: AndroidSettings.ApplicationDetails,
  settings: AndroidSettings.Settings,
  nfc: AndroidSettings.NfcSettings,
};

export const openNativeSettings = async (props: OpenNativeSettingsProps) => {
  const { option } = props;

  return await NativeSettings.open({
    optionAndroid: ANDROID_SETTINGS[option],

    // Based on docs: https://github.com/RaphaelWoude/capacitor-native-settings/tree/main?tab=readme-ov-file#open
    // Note that the only supported option by Apple is "App".
    // Using other options might break in future iOS versions or have your app rejected in the App Store.
    optionIOS: IOSSettings.App,
  });
};
